import { DocumentTemplateListPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentTemplatesList from 'modules/documents/components/DocumentTemplates/Content/DocumentTemplatesList'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const DocumentTemplatesPage = () => {
  const { loading, data, error } = useQuery(DocumentTemplateListPageDocument, {})

  const authorized = !loading && data?.documents?._policies?.templateManageDocumentTemplates.can

  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading}
      error={error}
      showHeader={false}
      authorized={authorized}
    >
      <DocumentTemplatesList />
    </ResponsivePage.Body>
  )
}

export default DocumentTemplatesPage
